import { ROLE_OWNER, type TenantSummary } from "@storytell/types";

// Org pages (billing included) are owner-only, so links to them resolve the
// current org when the user owns it, else any org they own. Not the primary
// tenant: primary marks the sign-up bootstrap org, which needn't be owned.
export function ownedOrgTenant(
  tenants: ReadonlyArray<TenantSummary>,
  currentOrgId: string | undefined
): TenantSummary | undefined {
  const current = tenants.find((t) => t.organizationId === currentOrgId);
  if (current?.organizationRole === ROLE_OWNER) return current;
  return tenants.find((t) => t.organizationRole === ROLE_OWNER);
}
